import { faArrowRotateLeft, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import iconNew from './icon-new.svg';
import { useNavPreferenceToggle } from './NavPreferenceToggle.hooks';

import * as styles from './NavPreferenceToggle.css';

function NavPreferenceToggle(): JSX.Element | null {
  const { t } = useTranslation();
  const { isDismissed, isUsingNewNav, handleToggle, handleDismiss } = useNavPreferenceToggle();

  if (isDismissed) {
    return null;
  }

  return (
    <div className={classNames(styles.root, { [styles.highlighted]: !isUsingNewNav })}>
      <button className={styles.toggleButton} onClick={handleToggle} type={'button'}>
        {isUsingNewNav ? (
          <FontAwesomeIcon className={styles.icon} icon={faArrowRotateLeft} />
        ) : (
          <img alt={''} className={styles.newIcon} src={iconNew} />
        )}
        <span className={classNames(styles.label, { [styles.labelHighlighted]: !isUsingNewNav })}>
          {isUsingNewNav ? t('Back to classic nav') : t('Try new navigation')}
        </span>
      </button>
      {!isUsingNewNav && (
        <button
          aria-label={t('Dismiss')}
          className={classNames(styles.closeButton, styles.closeButtonHighlighted)}
          onClick={handleDismiss}
          type={'button'}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
}

export default observer(NavPreferenceToggle);
